import { createSlice } from "@reduxjs/toolkit";

export const AuthSlice = createSlice({
    name: 'auth_slice',
    initialState: {
        professional_manual_registration: {},

    },
    reducers: {
        //onChange Professional inputs
        professional_registration_onChange(state, action) {
            return {
                ...state,
                professional_manual_registration: {
                    ...state.professional_manual_registration,
                    ...action.payload
                }
            }
        }
    }

    
})

const { actions, reducer } = AuthSlice;

export const {
    professional_registration_onChange,

    
} = actions;

export default reducer